import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [couple, setCouple] = useState(null);
  const [partner, setPartner] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("cp_token");
    if (!token) {
      setUser(null);
      setCouple(null);
      setPartner(null);
      setRole(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setCouple(data.couple);
      setPartner(data.partner);
      setRole(data.role);
    } catch (e) {
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    await refresh();
  };

  const register = async (name, email, password, account_type = "couple", relationship_stage = null) => {
    const { data } = await api.post("/auth/register", {
      name,
      email,
      password,
      account_type,
      relationship_stage,
    });
    setToken(data.token);
    await refresh();
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    setCouple(null);
    setPartner(null);
    setRole(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, couple, partner, role, loading, login, register, logout, refresh }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
